import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { media } from '../../styles/theme';

// Mesmo visual do Login: faixa navy em cima e cartão central
export const Container = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100dvh;
  padding: ${({ theme }) => theme.espaco.lg} ${({ theme }) => theme.espaco.lg} 72px;
  background:
    linear-gradient(180deg, ${({ theme }) => theme.cores.primary} 0 38%, ${({ theme }) => theme.cores.surface} 38% 100%);
`;

export const Cartao = styled.form`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: ${({ theme }) => theme.espaco.md};
  width: 100%;
  max-width: 420px;
  padding: ${({ theme }) => theme.espaco.xxl};
  background-color: ${({ theme }) => theme.cores.card};
  border: 1px solid ${({ theme }) => theme.cores.border};
  border-radius: ${({ theme }) => theme.raio.card};
  box-shadow: ${({ theme }) => theme.sombra.modal};
  text-align: center;

  img {
    align-self: center;
    height: 56px;
    width: auto;
    margin-bottom: ${({ theme }) => theme.espaco.sm};
  }

  h1 {
    font-size: ${({ theme }) => theme.fonte.h1};
    color: ${({ theme }) => theme.cores.ink};
  }

  .subtitulo {
    margin-bottom: ${({ theme }) => theme.espaco.sm};
    color: ${({ theme }) => theme.cores.inkSecondary};
  }

  ${media.mobile} {
    padding: ${({ theme }) => theme.espaco.xl} ${({ theme }) => theme.espaco.lg};

    h1 {
      font-size: ${({ theme }) => theme.fonte.h2};
    }
  }
`;

export const Empresa = styled.div`
  padding: ${({ theme }) => theme.espaco.md};
  border-radius: ${({ theme }) => theme.raio.md};
  background-color: ${({ theme }) => theme.cores.surface};

  strong {
    display: block;
    color: ${({ theme }) => theme.cores.ink};
  }

  small {
    color: ${({ theme }) => theme.cores.inkMuted};
    font-size: ${({ theme }) => theme.fonte.small};
  }
`;

export const ListaFiliais = styled.ul`
  display: grid;
  gap: ${({ theme }) => theme.espaco.sm};
  list-style: none;
  text-align: left;
`;

export const Filial = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.espaco.md};
  width: 100%;
  min-height: ${({ theme }) => theme.alturaControle.mobile};
  padding: 0 ${({ theme }) => theme.espaco.lg};
  border: 1px solid ${({ theme }) => theme.cores.border};
  border-radius: ${({ theme }) => theme.raio.md};
  background-color: ${({ theme }) => theme.cores.card};
  color: ${({ theme }) => theme.cores.ink};
  font-size: ${({ theme }) => theme.fonte.input};
  font-weight: 600;
  text-align: left;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  svg { color: ${({ theme }) => theme.cores.inkMuted}; flex-shrink: 0; }

  &:hover {
    border-color: ${({ theme }) => theme.cores.primary};
    background-color: ${({ theme }) => theme.cores.surface};
  }
`;

export const Links = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: ${({ theme }) => theme.espaco.sm};
  margin-top: ${({ theme }) => theme.espaco.xs};

  a, button {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: ${({ theme }) => theme.espaco.sm} 0;
    border: none;
    background: transparent;
    color: ${({ theme }) => theme.cores.primary};
    font-size: ${({ theme }) => theme.fonte.small};
    text-decoration: none;

    &:hover { text-decoration: underline; }
  }

  .whatsapp svg { color: ${({ theme }) => theme.cores.whatsapp}; }
`;

export const LinkInterno = styled(Link)``;
